import(/* webpackMode: "eager" */ "/vercel/path0/app/(dashboard)/(app)/token-burn/page.jsx");
